// assets
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
// icons
const icons = {
  CalendarOutlined,
  DashboardOutlined,
  FileTextOutlined,
  LineChartOutlined,
  UserOutlined
};

// ==============================|| MENU ITEMS - INCLUSION HEAD ||============================== //

// `catalogueCode` ties an item to the specific Features and Pages PAGE it shows
// (rbac_app_page.code), matched by CODE not URL: the inclusion head reaches the same
// screen at a role-prefixed URL (/inclusionhead/my-calendar) the catalogue route does
// not cover, so a URL match misses it. The page code — not the feature code — is used so
// switching off a single page hides it; a switched-off FEATURE reports all its pages as
// disabled, so that case is covered by the same code. Where no catalogue page matches
// (the dashboard, data-collection and reports directories), the feature code is the
// fallback. See menu-items/catalogueVisibility.js.
const inclusionhead = {
  id: 'group-inclusionhead',
  title: 'Inclusion Head',
  icon: icons.UserOutlined,
  type: 'group',
  children: [
    {
      id: 'inclusionhead-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/inclusionhead/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      catalogueCode: 'dashboard_reports'
    },
    {
      id: 'inclusionhead-child-profiles',
      title: 'Child Profiles',
      type: 'item',
      url: '/inclusionhead/child-profiles',
      icon: icons.UserOutlined,
      breadcrumbs: false,
      catalogueCode: 'child_directory'
    },
    {
      id: 'inclusionhead-data-collection',
      title: 'Data Collection',
      type: 'item',
      url: '/inclusionhead/data-collection',
      icon: icons.FileTextOutlined,
      breadcrumbs: false,
      catalogueCode: 'data_tracking'
    },
    {
      id: 'inclusionhead-my-calendar',
      title: 'Calendar',
      type: 'item',
      url: '/inclusionhead/my-calendar',
      icon: icons.CalendarOutlined,
      breadcrumbs: false,
      catalogueCode: 'my_calendar'
    },
    {
      id: 'inclusionhead-reports',
      title: 'Reports',
      type: 'item',
      url: '/inclusionhead/reports',
      icon: icons.LineChartOutlined,
      breadcrumbs: false,
      catalogueCode: 'dashboard_reports'
    }
  ]
};

export default inclusionhead;
